import React from "react";

const TxnActions = ({ onEdit, onDelete, title = "More options" }) => {
  return (
    <div className="dropdown">
      <a
        className="text-black btn p-0 bg-not-transparent-on-hover w-auto"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title={title}
      >
        <span className="bi bi-three-dots-vertical"></span>
      </a>
      <ul className="dropdown-menu dropdown-menu-end row w-auto">
        <li className="col-12 py-1">
          <button
            type="button"
            className="w-100 btn btn-outline-app rounded"
            onClick={onEdit}
          >
            <span className="bi bi-pencil-fill"> Edit</span>
          </button>
        </li>
        <li className="col-12 py-1">
          <button
            type="button"
            className="w-100 btn btn-app rounded"
            onClick={onDelete}
          >
            <span className="bi bi-trash"> Delete</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default TxnActions;
